import { Grid } from '@mui/material';
import React from 'react';
import {
  Button,
  ContractsTable,
  NoDataTable,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { scrollBarStyles } from '../../../../core-utils/messages/CommonConstants';
import contractAIQConstants from '../../../../core-utils/messages/ContractAIQConstants';
import { LegendItemProps } from '../../../../core-utils/types/contracts.types';
import InfoBar from '../../../atoms/InfoBar';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  root: {
    padding: '25px 24px 28px 24px',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  titleBlock: {
    display: 'flex',
    flexDirection: 'column',
  },
  legend: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    flexShrink: 0,
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  swatch: {
    width: '14px',
    height: '14px',
    borderRadius: '3px',
    border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
    flexShrink: 0,
  },
  contractsTable: {
    maxHeight: '336px',
    paddingRight: '4px',
    overflowY: 'auto',
    ...scrollBarStyles,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    marginTop: '20px',
    '@media (max-width: 768px)': { flexDirection: 'column' },
  },
});

interface Props {
  rowsData: any[];
  onProceedClick: () => void;
}

const CreatedContracts: React.FC<Props> = ({ rowsData, onProceedClick }) => {
  const { classes } = useStyles();
  const messages = contractAIQConstants.COMPLIANCE_ASSURANCE;

  const LegendItem: React.FC<LegendItemProps> = ({ color, label }) => (
    <Grid className={classes.legendItem}>
      <span
        className={classes.swatch}
        style={{ backgroundColor: color }}
        aria-hidden="true"
      />
      <Typography
        fontSize="12px"
        fontType="regular"
        lineHeight="18px"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
      >
        {label}
      </Typography>
    </Grid>
  );

  return (
    <Grid className={classes.root}>
      <Grid className={classes.headerRow}>
        <Grid className={classes.titleBlock}>
          <Typography
            fontSize="14px"
            fontType="semiBold"
            lineHeight="24px"
            textColor={patientAccessTheme.palette.text.highemphasis}
          >
            {messages.CONTRACTS.TITLE}
          </Typography>
          <Typography
            fontSize="12px"
            fontType="regular"
            lineHeight="24px"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
          >
            {messages.CONTRACTS.SUB_TITLE}
          </Typography>
        </Grid>

        <Grid className={classes.legend}>
          <LegendItem color={'#fff9cc'} label="Newly added document" />
          <LegendItem color={'#F5F8FA'} label="Existing document" />
        </Grid>
      </Grid>
      <Grid className={classes.contractsTable}>
        {rowsData?.length > 0 ? (
          <ContractsTable
            rowsData={rowsData}
            columns={[
              'Healthcare Partner',
              'Service Agreement Type',
              'Total Files',
              'Effective Date',
            ]}
          />
        ) : (
          <NoDataTable
            height={'100%'}
            width={'100%'}
            content={'No Contracts Available'}
          />
        )}
      </Grid>
      <Grid style={{ marginTop: '20px' }}>
        <InfoBar
          type="Info"
          width="100%"
          height="100%"
          info={`Your contracts have been created. Compliance checks and reports are now being generated.`}
        />
      </Grid>
      <Grid className={classes.actions}>
        <Button
          label="Proceed ↗"
          variant="contained"
          height="37px"
          width="auto"
          onClick={onProceedClick}
        />
      </Grid>
    </Grid>
  );
};

export default CreatedContracts;
